import React, { useState } from 'react';
import { post, getErrorMessage } from '../api/client';
import PageHeader from '../components/PageHeader';

const InvitePage = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error'
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setMessage('');
    if (!email.trim()) return;

    setLoading(true);
    const { ok, status: resStatus, data } = await post('/api/invitations', { email: email.trim() });
    setLoading(false);

    if (ok) {
      setStatus('success');
      setMessage(`Invitation sent to ${email.trim()}`);
      setEmail('');
    } else {
      setStatus('error');
      setMessage(getErrorMessage({ status: resStatus, data }, 'Failed to send invitation'));
    }
  };

  return (
    <div className="entry-page">
      <PageHeader title="Invite User" section="admin" />
      <p style={{ color: 'var(--cr-text-muted)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
        Send an invitation email. The user will sign up with their email and password.
      </p>
      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 400 }}>
        <div className="form-group">
          <label htmlFor="invite-email">Email address</label>
          <input
            id="invite-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="user@example.com"
            required
            disabled={loading}
          />
        </div>
        <button type="submit" disabled={loading} className="btn-primary">
          {loading ? 'Sending…' : 'Send invitation'}
        </button>
      </form>
      {status === 'success' && (
        <p style={{ color: 'var(--cr-text)', marginTop: '1rem', fontWeight: 500 }}>{message}</p>
      )}
      {status === 'error' && (
        <p style={{ color: 'var(--cr-error)', marginTop: '1rem' }}>{message}</p>
      )}
    </div>
  );
};

export default InvitePage;
